/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import React from 'react';
import { Box, Spinner, Text, Flex } from '@chakra-ui/react';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading…', fullPage = false }) => {
  const content = (
    <Flex direction="column" align="center" gap={3} p={8}>
      <Spinner size="xl" color="accent.solid" borderWidth="3px" />
      <Text fontSize="sm" color="fg.muted">
        {message}
      </Text>
    </Flex>
  );

  if (fullPage) {
    return (
      <Box
        position="fixed"
        inset={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="rgba(246,247,247,0.8)"
        zIndex={100}
      >
        {content}
      </Box>
    );
  }

  return <Flex justify="center">{content}</Flex>;
};
